import _merge from "lodash/merge";
import { CacheProvider, Global, ThemeProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import 'what-input';
import { theme } from '../assets/styles/theme';
import { fonts } from '../assets/styles/fonts';
import { globalStyles } from '../assets/styles/global'; // Handy-dandy utility function to deep-merge themes

import { jsx as ___EmotionJSX } from "@emotion/react";
export function extendTheme(...themes) {
  return _merge.apply(void 0, [{}].concat(themes));
}
export const createCKCache = () => createCache({
  key: 'ck',
  stylisPlugins: [prefixer]
});
export const ckCache = createCKCache();

const Wrapper = ({
  children
}) => ___EmotionJSX(CacheProvider, {
  value: ckCache
}, ___EmotionJSX(ThemeProvider, {
  theme: theme
}, ___EmotionJSX(Global, {
  styles: [globalStyles(theme), fonts(theme), process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;"]
}), children));

export default Wrapper;